import {
    createSkyNetObjectRoutes,
} from 'app/PoC/DataGridDemoPages/SkyNetObjectRoutes/SkyNetObjectRoutes.utils'

import ContractBasisDemoPage from './ContractBasisDemoPage'
import domainConfig from './ContractBasisDemo.config'

export default createSkyNetObjectRoutes(<ContractBasisDemoPage />, domainConfig)
